import { createSelector } from 'reselect';
import { getWorkOrderOpTotalParts } from './getWorkOrderOpTotalParts';
import { getLaborScopeTotalParts } from './getScopeTotalParts';
import { getIsLaborTicketEnabled } from './getIsLaborTicketEnabled';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';
import { getApmCurrentOrderQuantity } from './getApmCurrentOrderQuantity';

export const getOrderProgress = createSelector(
  [
    getWorkOrderOpTotalParts,
    getLaborScopeTotalParts,
    getIsLaborTicketEnabled,
    getIsApmERPJobFlow,
    getApmCurrentOrderQuantity,
  ],
  (
    workOrderOpTotalParts,
    laborScopeTotalParts,
    isLaborTicketEnabled,
    isApmERPJobFlow,
    apmCurrentOrderQuantity
  ) => {
    if (isApmERPJobFlow && apmCurrentOrderQuantity != null) {
      return apmCurrentOrderQuantity.completedQuantity;
    }
    if (isLaborTicketEnabled) {
      return workOrderOpTotalParts + laborScopeTotalParts;
    }
    return workOrderOpTotalParts;
  }
);
